import { fromJS, Set as ImmutableSet } from 'immutable';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import * as LocalStorageKeys from 'automation-ui-canvas/constants/LocalStorageKeys';
import * as localStorageUtils from 'automation-ui-canvas/utils/localStorageUtils';
function mapNumbersToSets(props) {
  return props.mapEntries(entry => [Number(entry[0]), ImmutableSet(entry[1])]);
}
function toLocalStorage(props) {
  const storage = fromJS(props);
  return storage.update(LocalStorageKeys.ONBOARDING_FOR_WAIT_UNTIL, waitUntilOnboarding => waitUntilOnboarding ? mapNumbersToSets(waitUntilOnboarding) : undefined);
}
const initialState = toLocalStorage(localStorageUtils.getWorkflowsLocalStorage() || {});
export default ((state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LOCAL_STORAGE_MERGE_DEEP:
      {
        const mergedState = state.mergeDeep(action.payload);
        const newState = localStorageUtils.setWorkflowsLocalStorage(mergedState);
        return newState;
      }
    default:
      return state;
  }
});